import { SidebarFooter, SidebarMenu, SidebarMenuItem, useSidebar } from "@/components/ui/sidebar";
import AvatarMenu from "./AvatarMenu";
import NotificationBell from "@/components/NotificationBell";

const Footer = () => {
  const { isMobile } = useSidebar();

  return (
    <SidebarFooter className="mt-auto shrink-0 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      {!isMobile && (
        <SidebarMenu>
          <SidebarMenuItem>
            <NotificationBell placement="sidebar" />
          </SidebarMenuItem>
        </SidebarMenu>
      )}
      <AvatarMenu />
    </SidebarFooter>
  );
};

export default Footer;
